export default {
  en: {
    title: 'Modify Profile',
    subtitle: 'Modify data of your profile',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    lang: 'Language',
    password: 'Password',
    confirm: 'Confirm Password',
    errors: {
      firstname: 'Please write a firstname',
      lastname: 'Please write a lastname',
      email: 'Please write a valid email',
      password: 'Write a password with a 6 characters minimum',
      confirm: 'The passwords aren\'t the same.',
      conflict: 'The email it\'s used by other user, please choose other.',
      unknown: 'Something not works, please try again.',
    },
    buttons: {
      password: 'Change password',
      save: 'Save changes',
    },
    passwordSection: {
      title: 'Change Password',
      subtitle: 'Changing your password will close all your sessions.',
    },
    success: {
      user: 'The profile changes was saved successful.',
      password: {
        title: 'The password was changed successful',
        subtitle: 'The active sessions will be closed.',
      },
    },
  },
  es: {
    title: 'Modificar Perfil',
    subtitle: 'Modique datos de su perfil',
    firstname: 'Nombres',
    lastname: 'Apellidos',
    email: 'Correo electrónico',
    lang: 'Idioma',
    password: 'Contraseña',
    confirm: 'Confirme Contraseña',
    errors: {
      firstname: 'Ingrese un nombre(s) válido',
      lastname: 'Ingrese un apellido(s) válido',
      email: 'Ingrese un email válido',
      password: 'Escriba una contraseña de 6 carácteres mínimo.',
      confirm: 'Las contraseñas no coinciden.',
      conflict: 'El correo electrónico está siendo utilizado por otro usuario, escoja otro.',
      unknown: 'Algo no funciona, intente nuevamente.',
    },
    buttons: {
      password: 'Cambiar contraseña',
      save: 'Guardar Cambios',
    },
    passwordSection: {
      title: 'Cambiar contraseña',
      subtitle: 'Cambiar su contraseña cerrará todas sus sesiones.',
    },
    success: {
      user: 'Los cambios de perfil se guardaron correctamente.',
      password: {
        title: 'La contraseña fue cambiada exitosamente',
        subtitle: 'Las sesiones activas se cerrarán.',
      },
    },
  },
};
